import React from 'react';

// import './Home.css';

import {NewPage} from './Tools'

function Title() {
  return (
    <div className="Title">
      <p>
        miaom's Blog
      </p>
    </div>
  );
}

function Index() {
  return (
    <div className="Index">
      <NewPage className="Link" to="/blog">博客</NewPage>
      <NewPage className="Link" to="/about">关于</NewPage>
    </div>
  );
}

function Home() {
  return (
    <div className="Home Item">
      <Title/>
      <hr/>
      <Index/>
    </div>
  );
}


export default Home;
